import { render, staticRenderFns } from "./widgets-group.vue?vue&type=template&id=d6561388&scoped=true&"
import script from "./widgets-group.vue?vue&type=script&lang=js&"
export * from "./widgets-group.vue?vue&type=script&lang=js&"
import style0 from "./widgets-group.vue?vue&type=style&index=0&id=d6561388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6561388",
  null
  
)

export default component.exports